module.exports = __webpack_public_path__ + "static/jumping-b1ef6e4fce0986683fa40b1c292ff05f.jpg";